import { render } from "./Concours.vue?vue&type=template&id=09fba88e&scoped=true"
import script from "./Concours.vue?vue&type=script&lang=js"
export * from "./Concours.vue?vue&type=script&lang=js"

import "./Concours.vue?vue&type=style&index=0&id=09fba88e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09fba88e"]])

export default __exports__